import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchCallerMe, fetchCallerAssignments, fetchCallerRecords, fetchCallerStats } from '../../lib/api';

export function useCallerMe() {
  return useQuery({
    queryKey: queryKeys.callerMe(),
    queryFn: fetchCallerMe,
    retry: false,
  });
}

export function useCallerAssignments() {
  return useQuery({
    queryKey: queryKeys.callerAssignments(),
    queryFn: fetchCallerAssignments,
  });
}

export function useCallerRecords(campaignId, params = {}) {
  const { block, page = 1, page_size = 50, search } = params;

  return useQuery({
    queryKey: queryKeys.callerRecords(campaignId, block, page, search),
    queryFn: () => fetchCallerRecords(campaignId, { block_number: block, page, page_size, search }),
    enabled: !!campaignId,
  });
}

export function useCallerStats(campaignId) {
  return useQuery({
    queryKey: queryKeys.callerStats(campaignId),
    queryFn: () => fetchCallerStats(campaignId),
    enabled: !!campaignId,
  });
}
